<template>
    <div class="tile-content">
        <div class="tile-subtitle">
            <h3>Additional Information</h3>
        </div>
        <p class="stack-m">This information can be useful for reporting and benchmark purposes. If you know it, please
            enter this information.</p>
        <div class="grid-content">
            <div class="grid-item grid-item-half grid-item-break-half">
                <v-select
                    label="Acquirer"
                    placeholder="Select acquirer"
                    :options="acquirerList"
                    :value="acquirerName"
                    @input="updateAcquirer"/>
            </div>
            <div class="grid-item grid-item-full">
                <v-select
                    label="Merchant Category Code"
                    placeholder="Select Category Code"
                    :options="mccList"
                    :value="merchantCategoryCode"
                    @input="updateMcc"/>
            </div>
        </div>
    </div>
</template>
<script>
    import {vSelect} from '@/components/form';
    import {MerchantCategoryCodesList} from '@/data/merchant-category-codes';
    import resolveEntity from '@/common/spec/resolve-entity';

    export default {
        name: 'additional-information',
        components: {vSelect},
        props: {
            acquirerName: {
                type: String,
            },
            merchantCategoryCode: {
                type: String,
            },
        },
        computed: {
            acquirerList() {
                return resolveEntity('GatewayAccount')
                    .acquirerName.enum
                    .map(name => ({label: name, value: name}));
            },
        },
        data() {
            return {
                mccList: [...MerchantCategoryCodesList],
            };
        },
        methods: {
            updateAcquirer(value) {
                this.$emit('input', {
                    acquirerName: value,
                    merchantCategoryCode: this.merchantCategoryCode,
                });
            },
            updateMcc(value) {
                this.$emit('input', {
                    acquirerName: this.acquirerName,
                    merchantCategoryCode: value,
                });
            },
        },
    };
</script>
